import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import AppLayout from "./components/AppLayout";
import AgentDevPanel from "./components/AgentDevPanel";

import CommandCenter from "./modules/CommandCenter";
import WitnessIntelligence from "./modules/WitnessIntelligence";
import AdmissibilityAudit from "./modules/AdmissibilityAudit";
import CaseAssistant from "./modules/CaseAssistant";
import Login from "./modules/Login";
import ROIDashboard from "./modules/ROIDashboard";
import Intake from "./modules/Intake";
import SecurityAudit from "./modules/SecurityAudit";
import { getWorkspaceId } from "./services/authStorage";

export default function App() {
  const showAgentPanel = String(import.meta.env.VITE_AGENT_PANEL || "1") !== "0";
  return (
    <BrowserRouter>
      {showAgentPanel ? <AgentDevPanel /> : null}
      <Routes>
        <Route path="/login" element={<Login />} />

        <Route element={<AppLayout />}>
          <Route path="/" element={<CommandCenter />} />
          <Route path="/intelligence" element={<WitnessIntelligence />} />
          <Route path="/admissibility" element={<AdmissibilityAudit />} />
          <Route path="/intake" element={<Intake />} />
          <Route path="/security" element={<SecurityAudit />} />
          <Route path="/roi" element={<ROIDashboard />} />

          <Route path="/exhibits" element={<Navigate to="/" replace />} />
          <Route
            path="assistant"
            element={(
              <CaseAssistant
                workspaceId={getWorkspaceId()}
                token=""
              />
            )}
          />
          <Route path="/verification" element={<Navigate to="/admissibility" replace />} />
          <Route path="/integrity" element={<Navigate to="/admissibility" replace />} />
          <Route path="/integrity-audit" element={<Navigate to="/admissibility" replace />} />
          <Route path="/compliance" element={<Navigate to="/admissibility" replace />} />
          <Route path="/vault" element={<Navigate to="/" replace />} />
          <Route path="/chronology" element={<Navigate to="/intelligence" replace />} />
          <Route path="/timeline" element={<Navigate to="/intelligence" replace />} />
          <Route path="/roadmap" element={<Navigate to="/" replace />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
